import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/CloseRounded'
import { useHistory } from 'react-router'

import styles from './styles'

const useStyles = makeStyles(styles)

const Header: React.FunctionComponent<any> = () => {
	const history = useHistory()
	const classes = useStyles()
	const goBack = useCallback(() => {
		history.goBack()
	}, [history])
	return (
		<div className={classes.headerContainer}>
			<>
				<IconButton className={classes.closeButton} onClick={goBack}>
					<CloseIcon />
				</IconButton>
				<div className={classes.titleSection}></div>
			</>
		</div>
	)
}

export default Header
